import script from "./OrderBlitzGame.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderBlitzGame.vue?vue&type=script&setup=true&lang=js"

import "./OrderBlitzGame.vue?vue&type=style&index=0&id=c870a768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c870a768"]])

export default __exports__